import React from 'react';
import { Pagination } from 'react-instantsearch/dom';
import {connectStateResults } from 'react-instantsearch/connectors';
import NotFound from './NotFound';
import CustomHits from './CustomHits';
import * as noImage from '../images/no-image.png';

const Results = connectStateResults(
     ({ searchState, searchResults }) =>
       searchState.query || searchState.range
       ? searchResults && searchResults.nbHits !== 0
         ? <section className="search-results">
             <Pagination
               pagesPadding={0}
               showNext
               showPrevious
               showFirst={false}
               translations={{next: '', previous: ''}}
            />
             <div className="search-list">
               <CustomHits
                  searchState={searchState}
                  // createURL={props.createURL}
                  // onSearchStateChange={props.onSearchStateChange}
                 />
             </div>
           </section>
         : <NotFound query={searchState.query} />
      : <section className="search-results search-results--no-query">
          <p className="message">Please enter a vintage, series number or a keyword to the search field. Or use the year range slider to find related Para Tawny information</p>
          <img src={noImage} alt="Para Tawny Timeline" className="welcome-image" />
        </section>
);

export default Results;



// WEBPACK FOOTER //
// ./src/components/Results.js